<template>
<add-edit-vessel></add-edit-vessel>
</template>
<script>
import AddEditVessel from "@/layouts/components/vessel-management/addedit-vessel.vue"
export default {
 components : {
   AddEditVessel
 },
};
</script>